import React from 'react'
import {
  Box,
  Typography
} from '@mui/material';

const Air = () => {
  return (
    <>
        <Box className="headingBtnWrap">
            <Typography variant="h1">Air</Typography>
        </Box>
    </>
  )
}

export default Air
